import { ImageFlag } from './ImageFlag'
import { TextFlag } from './TextFlag'

type AllCmsFlagsSection = {
  data: {
    displayPriority: string
    startDate: string
    endDate: string
    flagCollectionIds: string[]
    flagType: 'image' | 'text'
    imageAlt?: string
    imageContent?: string
    imageHeight?: string
    imageWidth?: string
    backgroundColor?: string
    textColor?: string
    textContent?: string
  }
  name: string
}

type TAllCmsFlags = {
  data: {
    cmsCollectionFlags: {
      sections: AllCmsFlagsSection[]
    }
  }
}

type TClusterHighlights = {
  id: string | null
  name: string | null
}

interface CollectionFlagsProps {
  allCmsFlags: TAllCmsFlags
  clusterHighlights: TClusterHighlights[] | null
}

export const CollectionFlags = ({
  allCmsFlags,
  clusterHighlights,
}: CollectionFlagsProps) => {
  const flags = allCmsFlags?.data?.cmsCollectionFlags?.sections
    ? [...allCmsFlags.data.cmsCollectionFlags.sections]
    : []

  if (!flags || flags?.length === 0) {
    return null
  }

  const date = new Date()

  const flagsFilterByDate = flags?.filter((flag) => {
    const formatStartDate = new Date(flag?.data?.startDate)
    const formatEndDate = new Date(flag?.data?.endDate)

    return formatStartDate <= date && formatEndDate >= date
  })

  const includesId = (
    array1: string[],
    array2: TClusterHighlights[] | null
  ) => {
    let hasId = false

    array1?.forEach((id1) => {
      array2?.forEach((id2) => {
        if (id1 === id2.id) {
          hasId = true
        }
      })
    })

    return hasId
  }

  const flagsFilterById = flagsFilterByDate?.filter((flag) =>
    includesId(flag?.data?.flagCollectionIds, clusterHighlights)
  )

  const flagsFilterBySort = flagsFilterById?.sort((flagA, flagB) => {
    if (
      parseInt(flagB?.data?.displayPriority, 10) >
      parseInt(flagA?.data?.displayPriority, 10)
    ) {
      return -1
    }

    if (
      parseInt(flagB?.data?.displayPriority, 10) <
      parseInt(flagA?.data?.displayPriority, 10)
    ) {
      return 1
    }

    return 0
  })

  return (
    <>
      {flagsFilterBySort?.map((flag, index) => {
        if (index >= 2) {
          return null
        }

        if (flag?.data?.flagType === 'text') {
          return (
            <TextFlag
              key={index}
              textContent={flag?.data?.textContent}
              backgroundColor={flag?.data?.backgroundColor}
              textColor={flag?.data?.textColor}
              index={index}
            />
          )
        }

        if (flag?.data?.flagType === 'image') {
          return (
            <ImageFlag
              key={index}
              imageContent={flag?.data?.imageContent}
              imageAlt={flag?.data?.imageAlt}
              imageWidth={flag?.data?.imageWidth}
              imageHeight={flag?.data?.imageHeight}
              index={index}
            />
          )
        }

        return <></>
      })}
    </>
  )
}
